import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import styles from "./ourCompanies.module.css";
import classes from "../ourTeam/ourTeam.module.css";
import NavBar from "../../components/NavBar/NavBar";
import Footer from "../../components/footer/footer";
import CenteredContent from "../../components/CenteredContent/index";
import Section from "../../components/financialSerices/index";
import firstImage from "../../assets/images/investment-bank.png";
import firstImageResponsive from "../../assets/images/divisionResponsive.png";
import nbfiImage from "../../assets/images/nbfi.png";
import nbfiImageResponsive from "../../assets/images/nbfiReponsive.png";
import FAQ from "../../components/FAQ/FAQ";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import CenterButtons from "../../components/centerButtons/index";
import FirstQuestion from "../../components/FAQ/firstQuestion";
import CSSManagment from "../../data/CSSManagment";
import AssetManagment from "../../data/AssetManagement";
import Card from "../../components/cardPerson";
import BrokerageImage from "../../assets/images/ourCompanies/Securities Brokerage.png";
import BrokerageResponsiveImage from "../../assets/images/ourCompanies/Securities BrokerageResponsive.png";
import AssetManagement from "../../assets/images/ourCompanies/Funds Management.png";
import AssetManagementResponsiveImage from "../../assets/images/ourCompanies/Funds ManagementResponsive.png";
import privateEquityImage from "../../assets/images/private-equity.png";
import privateEquityImageResponsiveImage from "../../assets/images/private-equityResponsive.png";
import ventureImage from "../../assets/images/equity-research.png";
import ventureImageResponsiveImage from "../../assets/images/equity-researchResponsive.png";
import kiweImage from "../../assets/images/ourCompanies/kiwe.png";
import kiweResponsiveImage from "../../assets/images/ourCompanies/kiweResponsive.png";
import cayashImage from "../../assets/images/ourCompanies/Cayesh.png";
import cayashResponsiveImage from "../../assets/images/ourCompanies/CayeshResponsive.png";
import mintImage from "../../assets/images/ourCompanies/Rectangle 300.png";
import arrowLeft from "../../assets/images/Kiwe-arrow-left.svg";
import arrowRight from "../../assets/images/Kiwe-arrow-right.svg";
const divisionTitles = [
  "Securities Brokerage",
  "Asset Management",
  "Private Equity",
  "Venture Capital",
];
const firstQuestionData = {
  title: "What Sets Us Apart?",
  questions: [
    {
      header: "Expertise & Reliability",
      text: "Our seasoned team offers in-depth market analysis, tailored recommendations, and flawless execution.",
    },
    {
      header: "Technology-Driven Solutions",
      text: "Proprietary tools and platforms empower clients to trade efficiently and effectively.",
    },
    {
      header: "Global Connectivity",
      text: "We are a trusted execution gateway for foreign and Gulf investors, ensuring smooth entry into the Egyptian market.",
    },
  ],
  images: {
    default: BrokerageImage,
    responsive: BrokerageResponsiveImage,
  },
};
const assetManagementData = {
  title: "Our Managed Funds:",
  questions: [
    {
      header: "Blom Bank Egypt Money Market Fund:",
      text: "Low-risk, liquid instruments for stable returns.",
    },
    {
      header: "Arope   Money   Market   Fund:",
      text: "Short-term,   high-liquidity   investments designed for steady performance.",
    },
    {
      header: "Blom Bank Egypt Fund:",
      text: "Growth-oriented equity investments aiming for capital appreciation and periodic income.",
    },
  ],
  images: {
    default: AssetManagement,
    responsive: AssetManagementResponsiveImage,
  },
};
const privateEquityData = {
  title: "Investor Advantages",
  questions: [
    {
      header: "Attractive Returns",
      text: "Targeting a 25% IRR post-expenses.",
    },
    {
      header: "Strategic   Safeguards",
      text: "Reserved   Matters   ensure   transparency   and protect minority shareholders.",
    },
    {
      header: "Market Visibility",
      text: "Planned listing on the stock exchange for enhanced transparency.",
    },
  ],
  images: {
    default: privateEquityImage,
    responsive: privateEquityImageResponsiveImage,
  },
};
const serviceCards1 = [
  {
    header: "A Trusted Partner:",
    content: "We deliver on client requirements seamlessly and effectively.",
  },
  {
    header: "Top-Tier Brokerage Services:",
    content: "Ranked among the top 10 Egyptian brokerage firms.",
  },
  {
    header: "Innovation & Reliability:",
    content:
      "Personalized solutions that combine market insight with innovative tools.",
  },
  {
    header: "Diverse Offerings:",
    content:
      "From same-day trading to advisory services on the Nilex Exchange.",
  },
];
const serviceCards2 = [
  {
    header: "Unmatched Expertise:",
    content: "Decades of market experience and deep research capabilities.",
  },
  {
    header: "Diverse Offerings:",
    content: "Tailored solutions for clients seeking above-market returns.",
  },
  {
    header: "Client-Centric   Approach:",
    content:
      "Transparency,   trust,   and   personalized guidance at every step.",
  },
];
const serviceCards3 = [
  {
    header: "Robust Governance:",
    content:
      "Led by industrial leaders from Ebdaa and CFH, ensuring top-tier corporate governance.",
  },
  {
    header: "Operational Excellence:",
    content:
      " Comprehensive support in licensing, regulatory guidance, and financial management.",
  },
  {
    header: "Sustainable Impact:",
    content:
      "Fueling  Egypt’s industrial  future   through innovation, growth, and attractive returns.",
  },
];
const OurCompanies = () => {
  const location = useLocation();
  const [activeButton, setActiveButton] = useState(0);
  const [currentIndex, setCurrentIndex] = useState(0);
  const pdfPath = `${process.env.PUBLIC_URL}/tariffs.pdf`;

  const handlePrevClick = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? services.length - 1 : prevIndex - 1
    );
  };

  const handleNextClick = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === services.length - 1 ? 0 : prevIndex + 1
    );
  };

  useEffect(() => {
    if (location.state && location.state.activeIndex !== undefined) {
      setActiveButton(location.state.activeIndex);
    }
  }, [location.state]);

  const services = [
    {
      title: "Same-Day/Intraday Trading",
      description:
        "Capitalize on short-term opportunities with advanced tools and automated order slicing.",
    },
    {
      title: "Technical Analysis",
      description:
        "Leverage daily insights, historical data, and predictive modeling for informed investment strategies.",
    },
    {
      title: "Margin Lending",
      description:
        "Access flexible funding with professional guidance on risk management.",
    },
    {
      title: "Over-the-Counter (OTC) Trading",
      description: "Safely trade unlisted securities under expert oversight.",
    },
    {
      title: "E-Trading Platform",
      description:
        "Trade online with live data, portfolio tracking, and smart order functionalities.",
    },
    {
      title: "Short Selling",
      description:
        "Benefit from market downturns with strategic short positions.",
    },
    {
      title: "Nilex Services",
      description:
        "As a Nominated Advisor, we guide SMEs through listing procedures on Egypt’s SME market.",
    },
  ];

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 2,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  return (
    <div>
      {" "}
      <NavBar />
      <CenterButtons
        activeButton={activeButton}
        setActiveButton={setActiveButton}
        contentButtons={divisionTitles}
        largeWidth={true}
      />
      {activeButton === 0 && (
        <>
          <CenteredContent
            title="Cairo Capital Securities (CCS)"
            paragraph="Your Trusted Gateway to the Egyptian Financial Market Founded in 2007 as the brokerage arm of CFH, Cairo Capital Securities (CCS) has 18 years of market experience, establishing itself as a reliable partner in Egypt’s financial sector. We are dedicated to providing transparent, professional, and compliant   brokerage   services, fully authorized by the Financial Regulatory Authority (FRA)."
          />
          <div className={styles.container}>
            <Section
              firstTitle="Our Commitment to Clients"
              firstDescription="At CCS, we deliver a comprehensive range of brokerage services—from traditional
trading   solutions   to   innovative   financial   products—catered   to   retail   investors,
institutions, and high-net-worth individuals. Through a blend of tailored advice,
advanced  trading  tools,  and seamless market  access,  we empower  clients  to
confidently navigate financial markets and make informed investment decisions."
              firstImage={firstImage}
              firstImageResponsive={firstImageResponsive}
              doubleCard={false}
            />
          </div>
          <CenteredContent
            title="Our Mission"
            paragraph="We aim to be the premier financial gateway for the Egyptian Stock Exchange and
regional markets, merging local market expertise with international best practices.
Our flexible offerings address the evolving needs of diverse clients, including
domestic investors, Gulf-based entities, and international institutions."
          />
          <div className={styles.conainerCard}>
            <h1 className={styles.header}>Our Pillars of Excellence</h1>
            <div className={styles.cardRow}>
              <div className={styles.card}>
                <div className={styles.cardContent}>
                  <div className={styles.cardTitle}>Informed Investing</div>
                  <p className={styles.cardParagraph}>
                    Robust research, reliable execution, and cutting-edge
                    technology ensure well-grounded decisions.
                  </p>
                </div>
              </div>
              <div className={styles.card}>
                <div className={styles.cardContent}>
                  <div className={styles.cardTitle}>
                    Innovation & Efficiency
                  </div>
                  <p className={styles.cardParagraph}>
                    Digital platforms and advanced tools streamline the trading
                    experience for faster, more accurate transactions.
                  </p>
                </div>
              </div>
              <div className={styles.card}>
                <div className={styles.cardContent}>
                  <div className={styles.cardTitle}>Global Accessibility</div>
                  <p className={styles.cardParagraph}>
                    We open Egypt’s market to the world, making it easy for
                    overseas investors to participate.
                  </p>
                </div>
              </div>
              <div className={styles.card}>
                <div className={styles.cardContent}>
                  <div className={styles.cardTitle}>SME Support</div>
                  <p className={styles.cardParagraph}>
                    As a Nominated Advisor for the Nilex Exchange, we help small
                    and medium-sized enterprises achieve sustainable growth.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <FirstQuestion
            title={firstQuestionData.title}
            questions={firstQuestionData.questions}
            images={firstQuestionData.images}
          />
          <FAQ title="Why Choose CCS?" serviceCards={serviceCards1} />

          <div className={styles.serviceSlider}>
            <h1 className={styles.header}>Our Services</h1>
            <Slider {...settings} className={styles.slider}>
              {services.map((service, index) => (
                <div key={index}>
                  <div className={styles.serviceCard}>
                    <h3>{service.title}</h3>
                    <p>{service.description}</p>
                  </div>
                </div>
              ))}
            </Slider>
            <div className={styles.container}>
              <div className={styles.leftSection}>
                <div className={styles.divisionList}>
                  <div>
                    <div className={styles.serviceCard}>
                      <h3>{services[currentIndex].title}</h3>
                      <p>{services[currentIndex].description}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className={styles.arrows}>
                <img
                  src={arrowLeft}
                  alt="arrowLeft"
                  onClick={handlePrevClick}
                  className={styles.arrow}
                  style={{ marginRight: "2rem" }}
                />
                <img
                  src={arrowRight}
                  alt="arrowRight"
                  onClick={handleNextClick}
                  className={styles.arrow}
                />
              </div>
            </div>
          </div>
          <div className={classes.container}>
            <h2 className={classes.header}>CCS Management Team</h2>
            <div className={classes.cardsRow}>
              {CSSManagment.slice(0, 3).map((card, index) => (
                <Card
                  key={index}
                  header={card.header}
                  paragraph={card.paragraph}
                  largeCardItem={true}
                />
              ))}
            </div>
            <div className={classes.cardsRow}>
              {CSSManagment.slice(3).map((card, index) => (
                <Card
                  key={index}
                  header={card.header}
                  paragraph={card.paragraph}
                  largeCardItem={true}
                />
              ))}
            </div>
          </div>
        </>
      )}
      {activeButton === 1 && (
        <>
          <CenteredContent
            title="Cairo Capital Asset Management (CCAM)"
            paragraph="A Legacy of Excellence
For over 25 years, Cairo Capital has delivered innovative investment solutions
tailored to a diverse clientele. Since our founding in 1995 as CFI, we have led
Egypt’s asset management field, achieving consistent, market-leading results. In
2023, acquiring Blom Egypt for Financial Investments further enhanced our
capabilities and broadened our offerings under the CCAM brand."
          />

          <div className={styles.container}>
            <Section
              firstTitle="A Track Record of Success"
              firstDescription="With over EGP 4 billion in assets under management, CCAM’s approach combines
deep fundamental analysis, stringent risk assessment, and personalized client
attention. We offer a range of products, including conventional equity funds,
Sharia-compliant portfolios, balanced and fixed-income investments, and money
market solutions."
              firstImage={nbfiImage}
              firstImageResponsive={nbfiImageResponsive}
              doubleCard={false}
            />
          </div>
          <FAQ title="Why CCAM?" serviceCards={serviceCards2} />
          <FirstQuestion
            title={assetManagementData.title}
            questions={assetManagementData.questions}
            images={assetManagementData.images}
          />
          <div className={classes.container}>
            <h2 className={classes.header3}>
              Asset Management - Management Team
            </h2>
            <div className={classes.cardsRow}>
              {AssetManagment.slice(0, 3).map((card, index) => (
                <Card
                  key={index}
                  header={card.header}
                  paragraph={card.paragraph}
                  largeCardItem={true}
                />
              ))}
            </div>
          </div>
        </>
      )}
      {activeButton === 2 && (
        <>
          <CenteredContent
            title="Cairo   Capital   Private   Equity (NIIF)"
            paragraph="Pioneering Early-Stage Industrial Opportunities
The Nile Industrial Investment Fund (NIIF) is Egypt’s first private equity fund
dedicated to early-stage industrial projects. With a targeted capacity of EGP 2.5
billion, NIIF leverages Egypt’s economic reforms and market dynamism to invest
in transformative, export-driven sectors that reduce import dependency and
strengthen the nation’s industrial base."
          />
          <div className={styles.conainerCard}>
            <h1 className={styles.header}>Strategic Focus</h1>
            <div className={styles.cardRow}>
              <div className={styles.card}>
                <div className={styles.cardContent}>
                  <div className={styles.cardTitle}>
                    Chemicals & Petrochemicals
                  </div>
                  <p className={styles.cardParagraph}>
                    Capitalize on global energy transitions and strong
                    acquisition interest.
                  </p>
                </div>
              </div>
              <div className={styles.card}>
                <div className={styles.cardContent}>
                  <div className={styles.cardTitle}>
                    Food Industries & Underserved Subsectors{" "}
                  </div>
                  <p className={styles.cardParagraph}>
                    Address market gaps to foster sustainable development.
                  </p>
                </div>
              </div>
              <div className={styles.card}>
                <div className={styles.cardContent}>
                  <div className={styles.cardTitle}>Diverse Portfolio</div>
                  <p className={styles.cardParagraph}>
                    Acquire significant minority stakes in 12–15 companies
                    (approx. EGP 200 million each) for balanced risk and
                    influence.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <FirstQuestion
            title={privateEquityData.title}
            questions={privateEquityData.questions}
            images={privateEquityData.images}
          />
          <CenteredContent
            title="Proven Pipeline & Expertise"
            paragraph="Over 60% of the fund is already secured across nine key investments, with
operations set to launch by 2024–2025. A typical holding period of 5–7 years
allows for optimal exit strategies, including IPOs and strategic sales."
          />
          <FAQ title="Why NIIF?" serviceCards={serviceCards3} />
        </>
      )}
      {activeButton === 3 && (
        <>
          <CenteredContent
            title="Cairo   Capital   Startup   Ventures (CCSV)"
            paragraph="Empowering Fintech Transformation
At Cairo Capital, we embrace technology’s potential to reshape financial services.
Our Startup Ventures arm invests in early-stage fintech and software companies
that enhance our operational infrastructure and service offerings."
          />
          <div className={styles.container}>
            <Section
              firstTitle="Strategic Alignment & Technological Advancement"
              firstDescription="We select ventures that complement our core businesses, leveraging innovation to
boost   efficiency,   enhance   client   experiences,   and   set   new   performance
benchmarks.   Through   these   collaborations,   we   integrate   cutting-edge
technologies, positioning Cairo Capital as a leader in financial innovation.."
              firstImage={ventureImage}
              firstImageResponsive={ventureImageResponsiveImage}
              doubleCard={false}
            />
            <CenteredContent
              title="Delivering Stakeholder Value"
              paragraph="By investing in ventures with above-market potential, we create exceptional value
for stakeholders and foster economic growth within Egypt and beyond.

Cairo Capital Startup Ventures is a catalyst for meaningful change, fostering an
entrepreneurial ecosystem that drives forward-thinking financial services. By
investing   in   transformative   ventures,   we   shape   the   future   of   finance—one
innovation at a time."
            />
          </div>
          <div className={styles.container}>
            <Section
              firstTitle="Kiwe"
              firstDescription="A mobile money app offering simplified financial management, from
payments to investing, ensuring financial inclusion and accessibility for all."
              firstImage={kiweImage}
              firstImageResponsive={kiweResponsiveImage}
              secondTitle="Mint"
              secondDescription="Established in 2025, Mint provides user-friendly investment tools,
real-time data, and transparent insights. This intuitive platform empowers
investors of all levels to confidently engage in financial markets."
              secondImage={mintImage}
              secondImageResponsive={mintImage}
              doubleCard={true}
            />
          </div>
        </>
      )}
      <Footer />
    </div>
  );
};

export default OurCompanies;
